module.exports = __webpack_public_path__ + "static/media/network-wired.5bb310c5.svg";